export const sortingDirection = { asc: "asc", desc: "desc", none: "none" };

export type SortingDirection = typeof sortingDirection[keyof typeof sortingDirection];